var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('validation-observer', {
    ref: _vm.id + '-observer',
    attrs: {
      "slim": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var invalid = _ref.invalid,
            changed = _ref.changed,
            dirty = _ref.dirty,
            handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.onSubmit);
            }
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-8"
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-2 col-form-label text-right",
          attrs: {
            "for": _vm.id + '-title'
          }
        }, [_vm._v(_vm._s(_vm.$t('notification.title')))]), _c('div', {
          staticClass: "col-sm-10"
        }, [_c('validation-provider', {
          attrs: {
            "vid": _vm.id + '-title',
            "name": "title",
            "rules": "max:255",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var classes = _ref2.classes,
                  errors = _ref2.errors;
              return [_c('div', [_c('b-form-input', {
                class: classes,
                attrs: {
                  "id": _vm.id + '-title',
                  "size": "sm",
                  "maxlength": "255"
                },
                model: {
                  value: _vm.value.title,
                  callback: function callback($$v) {
                    _vm.$set(_vm.value, "title", $$v);
                  },
                  expression: "value.title"
                }
              }), _c('span', {
                staticClass: "invalid-feedback"
              }, [_vm._v(_vm._s(errors[0]))])], 1)];
            }
          }], null, true)
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-2 col-form-label text-right required",
          attrs: {
            "for": _vm.id + '-text'
          }
        }, [_vm._v(_vm._s(_vm.$t('notification.text')))]), _c('div', {
          staticClass: "col-sm-10"
        }, [_c('validation-provider', {
          attrs: {
            "vid": _vm.id + '-text',
            "name": "text",
            "rules": "required",
            "slim": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref3) {
              var classes = _ref3.classes,
                  errors = _ref3.errors;
              return [_c('div', [_c('b-form-textarea', {
                class: classes,
                attrs: {
                  "id": _vm.id + '-text',
                  "size": "sm",
                  "rows": "6"
                },
                model: {
                  value: _vm.value.text,
                  callback: function callback($$v) {
                    _vm.$set(_vm.value, "text", $$v);
                  },
                  expression: "value.text"
                }
              }), _c('span', {
                staticClass: "invalid-feedback"
              }, [_vm._v(_vm._s(errors[0]))])], 1)];
            }
          }], null, true)
        })], 1)])]), _c('div', {
          staticClass: "col-md-4"
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-4 col-form-label text-right required",
          attrs: {
            "for": _vm.id + '-audience'
          }
        }, [_vm._v(_vm._s(_vm.$t('notification.audience')))]), _c('div', {
          staticClass: "col-sm-8"
        }, [_c('e-form-select', {
          attrs: {
            "id": _vm.id + '-audience',
            "name": "audience",
            "size": "sm",
            "rules": "required",
            "hide-placeholder": ""
          },
          model: {
            value: _vm.value.audience,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "audience", $$v);
            },
            expression: "value.audience"
          }
        }, _vm._l(_vm.audiences, function (audience) {
          return _c('option', {
            key: audience,
            domProps: {
              "value": audience
            }
          }, [_vm._v(" " + _vm._s(_vm.$t('notification.audience.' + audience)) + " ")]);
        }), 0)], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-4 col-form-label text-right",
          attrs: {
            "for": _vm.id + '-validFrom'
          }
        }, [_vm._v(_vm._s(_vm.$t('notification.validFrom')))]), _c('div', {
          staticClass: "col-sm-8"
        }, [_c('b-form-datepicker', {
          attrs: {
            "id": _vm.id + '-validFrom',
            "size": "sm",
            "reset-button": "",
            "label-reset-button": _vm.$t('notification.date.reset'),
            "placeholder": _vm.$t('notification.validFrom.empty'),
            "locale": _vm.$i18n.locale,
            "max": _vm.validUntilDate
          },
          model: {
            value: _vm.validFromDate,
            callback: function callback($$v) {
              _vm.validFromDate = $$v;
            },
            expression: "validFromDate"
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-4 col-form-label text-right",
          attrs: {
            "for": _vm.id + '-validUntil'
          }
        }, [_vm._v(_vm._s(_vm.$t('notification.validUntil')))]), _c('div', {
          staticClass: "col-sm-8"
        }, [_c('b-form-datepicker', {
          attrs: {
            "id": _vm.id + '-validUntil',
            "size": "sm",
            "reset-button": "",
            "label-reset-button": _vm.$t('notification.date.reset'),
            "placeholder": _vm.$t('notification.validUntil.empty'),
            "locale": _vm.$i18n.locale,
            "min": _vm.validFromDate
          },
          model: {
            value: _vm.validUntilDate,
            callback: function callback($$v) {
              _vm.validUntilDate = $$v;
            },
            expression: "validUntilDate"
          }
        })], 1)])])]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_vm.resetDone ? _c('div', {
          staticClass: "text-muted small pt-1"
        }, [_vm._v(_vm._s(_vm.$t('notification.resetRead.done')))]) : _vm._e()]), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', {
          staticClass: "form-group row justify-content-end"
        }, [_vm.canResetRead() ? _c('div', {
          staticClass: "col-sm-3"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-block btn-outline-secondary",
          attrs: {
            "id": _vm.id + '-resetReadButton',
            "type": "button"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.resetRead();
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('notification.resetRead')))])]) : _vm._e(), _vm.canModify() ? _c('div', {
          staticClass: "col-sm-3"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-block btn-outline-primary",
          attrs: {
            "id": _vm.id + '-saveButton',
            "type": "submit",
            "disabled": !(changed || dirty || _vm.datesChanged) || invalid
          }
        }, [_vm._v(_vm._s(_vm.$t('controls.save')))])]) : _vm._e(), _vm.canDelete() ? _c('div', {
          staticClass: "col-sm-3"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-block btn-outline-danger",
          attrs: {
            "id": _vm.id + '-deleteButton',
            "type": "button"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.deleteEntity();
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('controls.delete')))])]) : _vm._e()])])])])];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }